module.exports = __webpack_public_path__ + "7e1e4c821e61f59cdd20daa88837434c.MP3";